<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="cancelEvent.emit()">
            <img src="assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_logo_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_alt" | translate }}
                </label>
                <div class="col-xs-12">
                    <input class="form-control" [formControl]="alt" />
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_link" | translate }}
                </label>
                <div class="col-xs-12" [class.has-warning]="!link.valid && link.touched">
                    <input class="form-control" placeholder="https://example.com" [formControl]="link" />
                    <ng-container *ngIf="!link.valid && link.touched">
                        <small *ngIf="link.errors.pattern" class="help-block mb-0">
                            {{ "control_errors_invalid_link" | translate }}
                        </small>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
